module.exports = __webpack_public_path__ + "static/media/rails.d82eb63f.png";